import moment from 'moment';

const chooseNameByType = type => {
	switch (type) {
		case 1:
			return 'Consulta SMS';
		case 2:
			return 'Ubicación GPS compartida o señalada';
		case 3:
			return 'Ubicación GPS señalada';
		case 4:
			return 'Ubicación GPS compartida';
	}
};
const formatDate = date =>
	moment(date)
		.utc()
		.format('DD-MM-YYYY');
export const formatNotificationConfig = notificationConfig => ({
	...notificationConfig,
	type: chooseNameByType(notificationConfig.type),
	selectedDays: formatDate(notificationConfig.selectedDay),
});
